// extracted by mini-css-extract-plugin
export default {"cardOption":"CreateQuestions_cardOption__6wH2+"};